import { render, staticRenderFns } from "./RotationList.vue?vue&type=template&id=7f2df792&"
import script from "./RotationList.vue?vue&type=script&lang=js&"
export * from "./RotationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports